module.exports = __webpack_public_path__ + "static/blog-hero-469bdae56499ad33a43655d6ff3ba8a5.svg";